import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const CheckIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20,6 9,17 4,12" />
  </svg>
);

const MinusIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const AccordionItem = ({ pkg, index, isOpen, onToggle, labels }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(isOpen ? contentRef.current.scrollHeight : 0);
  }, [isOpen]);

  const num = String(index + 1).padStart(2, '0');

  return (
    <div className={`acc-item ${isOpen ? 'acc-item--open' : ''}`}>
      <button
        className="acc-trigger acc-trigger--pkg"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="acc-num">{num}</span>
        <span className="acc-title">{pkg.title}</span>
        <span className="acc-tag">{pkg.perfectFor.split(',')[0]}</span>
        <span className="acc-chevron">{isOpen ? '−' : '+'}</span>
      </button>

      <div className="acc-body" style={{ height: `${height}px` }}>
        <div className="acc-body-inner" ref={contentRef}>
          <div className="acc-perfect">
            <span className="acc-label">{labels.perfectFor}</span>
            <p>{pkg.perfectFor}</p>
          </div>

          <div className="acc-cols">
            <div className="acc-col">
              <span className="acc-label acc-label--pros">{labels.whatYouGet}</span>
              <ul>
                {pkg.pros.map((pro, i) => (
                  <li key={i}>
                    <span className="acc-check"><CheckIcon /></span>
                    {pro}
                  </li>
                ))}
              </ul>
            </div>

            <div className="acc-col">
              <span className="acc-label acc-label--cons">{labels.keepInMind}</span>
              <ul>
                {pkg.cons.map((con, i) => (
                  <li key={i}>
                    <span className="acc-minus"><MinusIcon /></span>
                    {con}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Accordion = () => {
  const { t } = useTranslation('packages');
  const packages = t('packages', { returnObjects: true });
  const labels = t('labels', { returnObjects: true });
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="accordion__container">
      {packages.map((pkg, index) => (
        <AccordionItem
          key={index}
          pkg={pkg}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
          labels={labels}
        />
      ))}
    </div>
  );
};

export default Accordion;
